import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

export const useValidationSchemaExportReferral = () => {
  const { t } = useTranslation();
  const validationSchema = useMemo(() => {
    return Yup.object().shape({
      fromDate: Yup.date().required(t('errors.requiredField')),
      toDate: Yup.date()
        .required(t('errors.requiredField'))
        .test('fromDate', t('errors.earlierStartDate'), function (toDate, context) {
          if (!toDate || !context.parent.fromDate) return true;
          const fromDate = new Date(context.parent.fromDate);
          return fromDate.getTime() <= new Date(toDate).getTime();
        }),
    });
  }, [t]);

  return { validationSchema };
};
